import React from "react";
import { Route } from "react-router-dom";
import Receiving from "../../../containers/modules/purchasing/receiving";
import AccessControl from "../../../components/utilities/Class/AccessControl";

export default function ReceivingRoutes(props) {
  const { authUser } = props;
  return (
    <Route
      path="receiving"
      index
      element={
        <AccessControl
          name={"Receiving List"}
          auth={authUser}
          component={() => <Receiving />}
        />
      }
    ></Route>
  );
}
